import { DocumentOutput } from '@allocab/allocab-driver-service-types';
import { DocumentInput } from '@allocab/allocab-driver-shared-types';
import { useMutation } from '@tanstack/react-query';

import { queryKeys } from '../services/datastore/queryKeys';
import { queryClient } from '../services/datastore/react-query';
import { driverApi } from '../services/network/Api';

type Input = Omit<DocumentInput, 'fileName'> & {
  file: File;
  onUploadProgress?: (_percent: number) => void;
};

const uploadDocument = (input: Input) => {
  const formData = new FormData();

  formData.append('file', input.file);
  formData.append('type', input.type);
  formData.append('side', input.side);
  formData.append('fileName', input.file.name);
  if (input.vehicleId) formData.append('vehicleId', input.vehicleId);
  if (input.driverKey) formData.append('driverKey', input.driverKey);

  return driverApi.postFormData<DocumentOutput>('/v1/document/upload', formData, {
    onUploadProgress: progressEvent => {
      if (progressEvent.total != null) {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);

        input.onUploadProgress?.(percentCompleted);
      }
    },
  });
};

export const useUploadDocument = () =>
  useMutation<DocumentOutput, unknown, Input>({
    mutationFn: uploadDocument,
    onSuccess: (document, { side, vehicleId }) => {
      queryClient.invalidateQueries(queryKeys.user.fetchDriverDocuments());
      queryClient.invalidateQueries(queryKeys.user.fetchAccountDocuments());
      queryClient.invalidateQueries(queryKeys.user.fetchVehicleDocuments());
      queryClient.invalidateQueries(queryKeys.user.fetchDocumentLink(document.id, { side }));
      if (vehicleId) queryClient.invalidateQueries(queryKeys.user.fetchVehicleDocuments(vehicleId));
    },
  });
